export const emailValidator = {
  required: '入力してください',
  minLength: { value: 3, message: '文字数が短すぎます' },
  pattern: {
    value: /.[^\n\r@\u2028\u2029]*@.+\..+/,
    message: 'メールアドレスを入力してください',
  },
};
